<div class="alignContent">
    <viz-http-status code="401"></viz-http-status>
</div>
